<script lang="ts" setup>
import { getCurrentPath } from '@/utils/common'
import { storeToRefs } from 'pinia'
import { useToast } from 'wot-design-uni'

const { toastOptions, currentPage } = storeToRefs(useGlobalToast())

const { close: closeGlobalToast } = useGlobalToast()

const toast = useToast('globalToast')
const currentPath = getCurrentPath()









watch(
  () => toastOptions.value,
  (newVal) => {
    if (newVal && newVal.show) {
      if (currentPage.value === currentPath) {
        toast.show(toastOptions.value)
      }
    } else {
      toast.close()
    }
  },
)
</script>

<script lang="ts">
export default {
  options: {
    virtualHost: true,
    addGlobalClass: true,
    styleIsolation: 'shared',
  },
}
</script>

<template>




  <wd-toast selector="globalToast" :closed="closeGlobalToast" />

</template>
